import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {DetallePagoDto, RequestFinalizaPago, ResultFinalizaTransaccion} from "../../shared/interfaces/recaudo";
import {
  IBanco,
  IGetPseTransactionDetalle, PseTransactionModel,
  RequestGeneraLinkPago, RequestTransactionByReference,
  ResponseGeneraLinkPago
} from "../../shared/interfaces/pse";
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class PseTransactionService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/pse-transaction`;
  }

  getPseTransactionDetalle(pago: number): Observable<IGetPseTransactionDetalle> {
    return this.http.get<IGetPseTransactionDetalle>(`${this.baseUrl}/detalle-pse/${pago}`);
  }

  getResultadoTransaccion(solicitud: number): Observable<DetallePagoDto> {
    const url = `${this.baseUrl}/resultado-transaction`;
    const params = new HttpParams().set('solicitud', solicitud);
    return this.http.get<DetallePagoDto>(url,  {params: params});
  }

  generaLinkpago(body: RequestGeneraLinkPago): Observable<ResponseGeneraLinkPago> {
    const url = `${this.baseUrl}/public/generar-link-pago`;
    return this.http.post<ResponseGeneraLinkPago>(url, body);
  }

  generaTransaccionByReferencia(body: RequestTransactionByReference): Observable<PseTransactionModel> {
    const url = `${this.baseUrl}/public/transaction-ticket-by-referencia`;
    return this.http.post<PseTransactionModel>(url, body);
  }

  finalizaTransactionByReferencia(body: RequestFinalizaPago): Observable<ResultFinalizaTransaccion> {
    const url = `${this.baseUrl}/public/finalizar-transaccion-ref`;
    return this.http.post<ResultFinalizaTransaccion>(url, body);
  }

  getAllBancos(): Observable<IBanco[]> {
    return this.http.get<IBanco[]>(`${this.baseUrl}/public/bancos`);
  }



}
